import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="partners-navigation"
export default class extends Controller {
  static targets = ["householdInfoContainer", "householdInfoClosedContainer", "householdInfoOpenContainer", "householdInfoToggleSwitch"]

  connect() {
  }

  toggleHouseholdInfo(event) {
    if (this.targets.has("householdInfoContainer")) {
      this.householdInfoContainerTarget.classList.toggle("hidden")

      if (this.householdInfoContainerTarget.classList.contains("hidden")) {
        this.householdInfoToggleSwitchTarget.innerHTML = "Show settings to customize."
      } else {
        this.householdInfoToggleSwitchTarget.innerHTML = "Hide settings."
      }
    } else {
      this.householdInfoClosedContainerTarget.classList.toggle("hidden")
      this.householdInfoOpenContainerTarget.classList.toggle("hidden")
    }
  }
}
